import React from "react";
import Classes from "./styles/style.module.css";

import BrownBg from "../../images/lig/brownButtonBG.png";
import GreenBg from "../../images/lig/greenButtonBG.png";
import BlueBg from "../../images/lig/lightBlueButtonBG.png";
import lightGreenBg from "../../images/lig/lightGreenButtonBG.png";
import PurpleBg from "../../images/lig/purpleButtonBg.png";
import YellowBg from "../../images/lig/yellowButtonBG.png";

import FlagIcon from "../../images/lig/flagIcon.png";
import GiftIcon from "../../images/lig/giftIcon.png";
import HelpDeskIcon from "../../images/lig/helpDeskIcon.png";
import MessionIcon from "../../images/lig/messoinIcon.png";
import PodiumIcon from "../../images/lig/podiumIcon.png";
import RulesIcon from "../../images/lig/rulesIcon.png";

const BGgenerator = (title, size) => {
  switch (title) {
    case "شروع چالش":
      return (
        <>
          <img
            src={YellowBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="YellowBg"
          />
          <img src={FlagIcon} className={Classes.icon} alt="icon" />
        </>
      );
    case "معرفی":
      return (
        <>
          <img
            src={BlueBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="BlueBg"
          />
          <img src={MessionIcon} className={Classes.icon} alt="icon" />
        </>
      );
    case "پیشتازان":
      return (
        <>
          <img
            src={GreenBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="GreenBg"
          />
          <img src={PodiumIcon} className={Classes.icon} alt="icon" />
        </>
      );
    case "پشتیبانی":
      return (
        <>
          <img
            src={PurpleBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="PurpleBg"
          />
          <img src={HelpDeskIcon} className={Classes.icon} alt="icon" />
        </>
      );
    case "قوانین":
      return (
        <>
          <img
            src={lightGreenBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="lightGreenBg"
          />
          <img src={RulesIcon} className={Classes.icon} alt="icon" />
        </>
      );
    case "امتیاز بیشتر":
      return (
        <>
          <img
            src={BrownBg}
            className={`${Classes.bgImage} ${
              size === "large" ? Classes.largeBg : Classes.smallBg
            }`}
            alt="BrownBg"
          />
          <img src={GiftIcon} className={Classes.icon} alt="icon" />
        </>
      );

    default:
      break;
  }
};

const LigMenuButtom = ({ title, size, handleClick }) => {
  return (
    <div
      className={`${Classes.CustomButtom} ${
        size === "large" ? Classes.largeButton : Classes.smallButton
      }`}
      onClick={handleClick}
    >
      {BGgenerator(title, size)}
      <p className={size === "large" ? Classes.largetext : ""}>{title}</p>
    </div>
  );
};

export default LigMenuButtom;
